import { jsxs as s, jsx as t } from "react/jsx-runtime";
import "react";
import { classes as o } from "../../utils/helpers.js";
import '../../assets/ImageReplacementAnchor.css';const a = {
  "image-replacement-anchor": "_image-replacement-anchor_hx29b_1",
  "image-replacement-anchor__text": "_image-replacement-anchor__text_hx29b_14"
};
function g({
  href: n = "",
  target: r = "_self",
  image: e = { url: "", width: 1, height: 1 },
  text: l = "",
  height: m = 4,
  baselineAdjustment: c = 0,
  classname: i = ""
}) {
  return /* @__PURE__ */ s(
    "a",
    {
      className: o([
        a["image-replacement-anchor"],
        "image-replacement-anchor",
        i
      ]),
      href: n,
      target: r,
      rel: r === "_blank" ? "noreferrer" : null,
      style: {
        "--ira-aspect-ratio": e.width / e.height,
        "--ira-height": `${m}rem`,
        "--ira-baseline-adjustment": `${c}rem`
      },
      children: [
        /* @__PURE__ */ t("img", { src: e.url, className: a["image-replacement-anchor__image"], alt: "", role: "presentation", loading: "lazy" }),
        /* @__PURE__ */ t("span", { className: a["image-replacement-anchor__text"], children: l })
      ]
    }
  );
}
export {
  g as ImageReplacementAnchor,
  g as default
};
